module.exports = __webpack_public_path__ + "static/media/CircularStd-BlackItalic.0cda47fe.otf";